// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"24\" viewBox=\"0 0 20 24\"> <path id=\"iconmonstr-clipboard-5\" d=\"M22,2V24H2V2H5C6.23,2,7.181.916,8,0h8c.82.916,1.771,2,3,2ZM11,3a1,1,0,1,0,1-1A1,1,0,0,0,11,3Zm9,1H16L14,6H10.1L8,4H4V22H20Z\" transform=\"translate(-2)\" fill=\"#888\"/> </svg> ";
// Exports
module.exports = code;